import React from 'react';
import PropTypes from 'prop-types';
import difference from 'lodash/difference';
import styles from './CategoryList.css';
import CategoryListItem from './CategoryListItem.js';
import includes from 'lodash/includes';

export default function CategoryList({
  widgetCategories = [],
  selectedCategory = '',
  setSelectedCategory = () => undefined
}) {
  const SPECIAL_CATEGORIES = [
    'See All',
    'Popular',
    'Custom',
    'Reading Lists',
    'Mobile',
  ];

  // TODO: Not make this so hacky
  if (includes(widgetCategories, 'Search Results')) {
    SPECIAL_CATEGORIES.unshift('Search Results');
  }

  if (includes(widgetCategories, 'Labs')) {
    SPECIAL_CATEGORIES.push('Labs');
  }

  function renderListItem(categoryName) {
    return (
      <CategoryListItem
        onClick={() => setSelectedCategory(categoryName)}
        categoryName={categoryName}
        selected={selectedCategory === categoryName}
        key={categoryName}
      />
    );
  }

  return (
    <nav className={styles.categoryList}>
      <div className={styles.outerContainer}>
        <div className={styles.staticContainer}>
          <ul className={styles.categoryGroup}>
            {SPECIAL_CATEGORIES.map(renderListItem)}
          </ul>
        </div>
        <div className={styles.scrollContainer}>
          <ul className={styles.categoryGroup}>
            {difference(widgetCategories, SPECIAL_CATEGORIES).map(renderListItem)}
          </ul>
        </div>
        <div className={styles.scrollFade} />
      </div>
    </nav>
  );
}

CategoryList.propTypes = {
  selectedCategory: PropTypes.string,
  setSelectedCategory: PropTypes.func,
  widgetCategories: PropTypes.arrayOf(PropTypes.string)
};

